const allowEditAndDeleteStates = {
  draft: "Draft",
  submitted: "Submitted",
  open: "Open",
  ready_for_approval: "Ready for Approval",
};

const allowEditAttachmentsStates = {
  draft: "Draft",
  submitted: "Submitted",
  open: "Open",
  ready_for_approval: "Ready for Approval",
  signature_in_progress: "Signature in Progress",
  completed: "Completed",
};

const permissionApiNames = {
  canEditAllIncidents: "editAllIncidentsPostSubmission",
  canEditAllIncidentsPostSubmission: "editAllIncidentsPostSubmission",
  canEditOwnPostSubmission: "editOwnIncidentPostSubmission",
  canEditOwnPreSubmission: "editOwnIncidentPreSubmission",
};

export const getFacilityEditPermissions = (
  userFacilities: any,
  activeFacilityId: string,
  incidentStatus: string | undefined,
  loggedInUser: string,
  incidentCreatorId: string
) => {
  const isEditAllowed = incidentStatus
    ? Object.values(allowEditAndDeleteStates).includes(incidentStatus)
    : false;
  const facilityDetails = userFacilities.find(
    (facility: { facilityId: string }) =>
      facility.facilityId === activeFacilityId
  );
  let permissionName: string = "";
  if (incidentCreatorId && loggedInUser === incidentCreatorId) {
    switch (incidentStatus) {
      case allowEditAndDeleteStates["draft"]:
        permissionName = permissionApiNames.canEditOwnPreSubmission;
        break;
      case allowEditAndDeleteStates["submitted"]:
      case allowEditAndDeleteStates["open"]:
      case allowEditAndDeleteStates["ready_for_approval"]:
        permissionName = permissionApiNames.canEditOwnPostSubmission;
        break;
      default:
        break;
    }
  } else {
    permissionName = permissionApiNames["canEditAllIncidents"];
  }

  const incidentManagementPermissions =
    facilityDetails?.permissions.incidentManagementPermissions ?? [];
  const editPermission = incidentManagementPermissions.find(
    (permission: { apiName: string }) => permission.apiName === permissionName
  );

  return {
    canUserEditPostSubmission:
      (editPermission?.permissionValue && isEditAllowed) || false,
    editPermission: !!editPermission?.permissionValue,
  };
};

export const getFacilityEditAttachmentsPermissions = (
  userFacilities: any,
  activeFacilityId: string,
  incidentStatus: string | undefined,
  loggedInUser: string,
  incidentCreatorId: string
) => {
  let isEditAllowed = incidentStatus
    ? Object.values(allowEditAttachmentsStates).includes(incidentStatus)
    : false;
  const facilityDetails = userFacilities.find(
    (facility: { facilityId: string }) =>
      facility.facilityId === activeFacilityId
  );

  let permissionName: string = "";
  if (incidentCreatorId && loggedInUser === incidentCreatorId) {
    switch (incidentStatus) {
      case allowEditAttachmentsStates["draft"]:
        permissionName = permissionApiNames.canEditOwnPreSubmission;
        break;
      case allowEditAttachmentsStates["open"]:
        permissionName = permissionApiNames.canEditOwnPostSubmission;
        break;
      default:
        break;
    }
  }
  
  if (incidentStatus === allowEditAttachmentsStates["signature_in_progress"] 
    || incidentStatus === allowEditAttachmentsStates["submitted"]
    || incidentStatus === allowEditAttachmentsStates["completed"])
    permissionName = permissionApiNames.canEditAllIncidentsPostSubmission;
  
  const incidentManagementPermissions =
    facilityDetails?.permissions.incidentManagementPermissions ?? [];
  const editPermission = incidentManagementPermissions.find(
    (permission: { apiName: string }) => permission.apiName === permissionName
  ); 
  
  if (editPermission && editPermission.apiName === permissionApiNames.canEditAllIncidentsPostSubmission){
    isEditAllowed = editPermission?.permissionValue;
  }

  return {
    canUserEditPostSubmission:
      (editPermission?.permissionValue && isEditAllowed) || false,
    editPermission: !!editPermission?.permissionValue,
  };
};


